module.exports = __webpack_public_path__ + "images/external_images/img/400x180/img3.jpg";